import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../shared/services/client.service';
import { ManagedClient } from '../../shared/models/managed-client';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import {DacConfig} from "../../shared/services/dac-config.service";
import { User } from 'app/shared/models/user';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from 'app/login/services/auth.service';

// Todo: Stephen I'm not sure how much the wordpress stuff works and may just need to be removed.
@Component({
  selector: 'app-client-new',
  templateUrl: './client-new.component.html',
  styleUrls: ['./client-new.component.css']
})
export class ClientNewComponent implements OnInit {

  private _client: ManagedClient;
  public password:string;
  public confirmPassword:string;
  public isSaving:boolean;
  public clientName:string;
  private _generatingClientId:boolean;

  constructor(
    private _clientService: ClientService,
    private router: Router,
    private location: Location,
    private alertService: AlertService,
    private authService:AuthService,
    private dacConfig:DacConfig
  ) {
    this._client = new ManagedClient();
    this.authService.getCurrentUser().then(user => {
      this._client.user = user;
    });
    this.isSaving = false;
  }

  ngOnInit() {
    this.generateClientId();
  }

  get isGeneratingClientId() {
    return this._generatingClientId;
  }
  generateClientId() {
    this._generatingClientId = true;
    this._clientService.generateClientId().then(id => {
      this._client.id = id;
      this._generatingClientId = false;
    })
    .catch(error => {
      this.alertService.error("There was an error generating the client id for this client.  Please press the generate button again or contact support");
      console.error(error);
    });
  }

  goBack() {
    this.location.back();
  }

  get shouldShowEmailTemplate() {
    return this.dacConfig.isFeatureEnabled("assessments.manage.emailtemplate");
  }


  
  get Client(): ManagedClient {
    return this._client;
  }

  set Client(v: ManagedClient) {
    this._client = v;
  }

  get showPasswordFields() {
    return false;
  }

  private validate() : string[] {
    let errors = [];
    if (this.showPasswordFields) {
      if (this.password.trim() === "") {
        errors.push("Password cannot be empty");
      }
      else if (this.password !== this.confirmPassword) {
        errors.push("Passwords do not match");
      }
      else if (this.password.length < 8) {
        errors.push("Password must be at least 8 characters long");
      }
    }
    if (this._client.id === null
        || this._client.id.trim() === "") {
      errors.push("Unique Client Login ID cannot be empty");
    }
    return errors;
  }

  setUser(user:User) {
    this.Client.user = user;
  }

  save(isValid:boolean): void {
    if (!isValid) {
      this.alertService.error("You must fill in all required fields");
      return;
    }
    
    let errors = this.validate();
    if (errors.length) {
      this.alertService.error(errors.join("."), 3000);
      return;
    }
    this.isSaving = true;
    this._client.customField1 = this._client.id;
    this._clientService.createClient(this._client).then((client) => {
      this.handleClientCreateSuccess();
    })
    .catch((error) => {
      this.isSaving = false;
      console.error(error);
      if (error._code && error._code == "DUP_ENTRY") {
        this.alertService.error("That Unique Token already exists.  Please choose another one.", 3000);
      }
      else {
        this.alertService.error("An error occurred in saving this client.  Try again or contact customer support", 3000);
      }
    });
   
  }

  private handleClientCreateSuccess() {
    this.alertService.success("Client was created");
    setTimeout(() => {
      this.isSaving = false;
      this.router.navigate(['admin','client',this._client.id], {replaceUrl:true});
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/client-new/client-new.component.ts